import { useState } from 'react'
import { useForm } from '@tanstack/react-form'
import classNames from 'classnames'
import { createFieldValidators } from '../../tools/validation'

const EditAccount = ({ intialFormValue, action, onSave, onAdd }) => {
  const form = useForm({
    defaultValues: intialFormValue,

    onSubmit: ({ value }) => {
      if (action === 'edit') {
        onSave(value)
      }
      if (action === 'add') {
        onAdd(value)
      }
    },
  })

  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="edit-users-form-container">
      <form.Field name="buyer" validators={createFieldValidators(value => !value && 'Buyer is required')}>
        {field => (
          <div className="form-group">
            <label className="form-label">Buyer number/email</label>
            <input
              type="text"
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              placeholder="Enter buyer"
            />
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field name="auction" validators={createFieldValidators(value => !value && 'Auction is required')}>
        {field => (
          <div className="form-group">
            <label className="form-label">Auction</label>
            <select
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
            >
              <option value="" disabled>
                Select auction
              </option>
              <option value="Copart">Copart</option>
              <option value="IAAI">IAAI</option>
            </select>
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field name="comment">
        {field => (
          <div className="form-group">
            <label className="form-label">Comment</label>
            <input
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              type="text"
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              placeholder="Enter comment"
            />
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      {action !== 'add' && (
        <div className="switcher" style={{ cursor: 'pointer' }}>
          <label htmlFor="show-password" style={{ marginRight: '10px', cursor: 'pointer' }}>
            Change password
          </label>
          <input type="checkbox" id="show-password" onChange={e => setShowPassword(e.target.checked)} />
        </div>
      )}

      {(showPassword || action === 'add') && (
        <form.Field
          name="password"
          validators={createFieldValidators(value => !value && action === 'add' && 'Password is required')}
        >
          {field => (
            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                type="password"
                className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
                onChange={event => field.handleChange(event.target.value)}
                value={field.state.value}
                placeholder="Enter password"
              />
              {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
            </div>
          )}
        </form.Field>
      )}

      <div className="submit-button-container">
        {action === 'edit' && (
          <button className="save-user-button" onClick={form.handleSubmit}>
            Save
          </button>
        )}

        {action === 'add' && (
          <button className="save-user-button" onClick={form.handleSubmit}>
            Add new
          </button>
        )}
      </div>
    </div>
  )
}

export default EditAccount
